import { CONCENTRATION } from '@/constants';

export const concentrationFormatter = (params: any) => {
  const value = params.value;
  return (
    Object.entries(CONCENTRATION).find(([key, val]) => val === value)?.[0] ?? ''
  );
};
